/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';

export interface TablePaginationSignature {
  Args: {
    itemCount: number;
    page: number;
    pageSize: number;
    setPage: (size: number) => void;
    setPageSize: (size: number) => void;
  };
}

export default class TablePaginationComponent extends Component<TablePaginationSignature> {
  pageSizeOptions = [5, 10, 20];

  get startItem() {
    return (this.args.page - 1) * this.args.pageSize + 1;
  }

  get endItem() {
    return Math.min(
      this.args.itemCount,
      this.startItem + this.args.pageSize - 1,
    );
  }

  get canGotoNextPage() {
    return this.endItem !== this.args.itemCount;
  }

  get canGotoPreviousPage() {
    return this.startItem !== 1;
  }

  get totalPages() {
    return Math.ceil(this.args.itemCount / this.args.pageSize);
  }

  get pageJumpOptions() {
    return Array.from({ length: this.totalPages }).map(
      (value, index) => index + 1,
    );
  }

  @action
  changePageSize(selected: unknown) {
    const option = parseInt(selected as string);
    this.args.setPageSize(option);
    this.args.setPage(1);
  }

  @action
  changePage(selected: unknown) {
    const option = parseInt(selected as string);
    this.args.setPage(option);
  }

  @action
  nextPage() {
    this.args.setPage(this.args.page + 1);
  }

  @action
  previousPage() {
    this.args.setPage(this.args.page - 1);
  }
}
